import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  addDoc,
  updateDoc,
  deleteDoc,
  orderBy,
  startAfter,
  getCountFromServer,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "events", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getEvents = async (last) => {
  try {
    const q = last
      ? query(
          collection(db, "events"),
          orderBy("createdAt", "desc"),
          startAfter(last),
          limit(10),
        )
      : query(
          collection(db, "events"),
          orderBy("createdAt", "desc"),
          limit(10),
        );

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const events = documentSnapshots.docs.map((doc) => {
      return { ...doc.data(), id: doc.id };
    });

    // Get the total count of events in the collection
    const countQuery = query(collection(db, "events"));
    const countSnapshot = await getCountFromServer(countQuery);
    const totalEventsCount = countSnapshot.data().count;

    // Return events, last document, and total count of events
    return { events, last: lastVisible, totalEventsCount };
  } catch (error) {
    console.error(`Error while getting events: ${error}`);
    return error;
  }
};

export const getEventsLength = async () => {
  const collectionRef = collection(db, "events");
  const snapshot = await getDocs(collectionRef);
  return snapshot.size;
};

export const getEventById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const lesson = docSnap.data();
  return docSnap.exists ? { id: docSnap.id, ...lesson, reviewers: [] } : null;
};

export const createEvent = async (event) => {
  try {
    await addDoc(collection(db, "events"), event);
    return event;
  } catch (e) {
    console.error(`Error while creating event ${e}`);
    return false;
  }
};

export const updateEvents = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating event ${e}`);
    return false;
  }
};

export const deleteEvent = async (id) => {
  try {
    await deleteDoc(getDocument(id));
  } catch (e) {
    console.error(`Error while deleting events ${e}`);
    return false;
  }
};
